export function hasSpecialCharacters(input: string) {
  return /[^a-zA-Z0-9()_.\-\s]/.test(input);
}
